/**
 * Analytics consent (AVG/GDPR).
 * Bewaart de keuze in localStorage en publiceert wijzigingen via een
 * `consent-changed` window event zodat andere modules (analytics) reageren.
 */

export type ConsentStatus = "granted" | "denied" | "unknown";

export const CONSENT_KEY = "consent:analytics";
export const CONSENT_EVENT = "consent-changed";

export function getConsent(): ConsentStatus {
  if (typeof window === "undefined") return "unknown";
  try {
    const v = window.localStorage.getItem(CONSENT_KEY);
    if (v === "granted" || v === "denied") return v;
  } catch {
    /* noop */
  }
  return "unknown";
}

export function setConsent(status: "granted" | "denied") {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(CONSENT_KEY, status);
  } catch {
    /* noop */
  }
  try {
    window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: { status } }));
  } catch {
    /* noop */
  }
}

export function hasAnalyticsConsent(): boolean {
  return getConsent() === "granted";
}
